import { toast } from 'react-toastify';
import { ToastAlert } from '~components';

export default (msg: string, type?: string) =>
  toast(({ closeToast }) => (
    <ToastAlert msg={msg} type={type} closeToast={closeToast} />
  ));
